import {
  CURRENT_OVERVIEW,
  loadDetails,
  propertyChange,
  REFRESH_DETAILS_PAGE
} from "../../../ducks/respondentsOverview";
import {
  jumpToPage,
  OTHER_ANSWER_ID,
  QUESTION_VALIDATIONS,
  SHOW_OVERVIEW_MENU,
  showHideOverview,
  SURVEY_CURRENT_PAGE,
  SURVEY_RESULT,
  TRIGGER_STATE
} from "../../../ducks/surveyView";
import {
  READ_ONLY,
  READ_ONLY_BY_PERMISSIONS,
  saveSurveyResultAndStayInRunner,
  SENDING_DATA_IS_IN_PROGRESS
} from "../../../ducks/surveyRunner";

import SurveyFooter from "./SurveyFooter";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { hidePreviewSurvey } from "../../../ducks/survey";
import { loadPredefinedList } from "../../../ducks/surveyEditorActions";

const mapStateToProps = (state) => {
  return {
    surveyCurrentPage: state.surveyView[SURVEY_CURRENT_PAGE],
    showOverviewMenu: state.surveyView[SHOW_OVERVIEW_MENU],
    surveyResult: state.surveyView[SURVEY_RESULT],
    questionValidations: state.surveyView[QUESTION_VALIDATIONS],
    triggerState: state.surveyView[TRIGGER_STATE],
    OtherAnswer: state.surveyView[OTHER_ANSWER_ID],
    refreshDetailsPage: state.respondentsOverview[REFRESH_DETAILS_PAGE],
    currentOverview: state.respondentsOverview[CURRENT_OVERVIEW],
    sendingDataIsInProgress: state.surveyRunner[SENDING_DATA_IS_IN_PROGRESS],
    readonly: state.surveyRunner[READ_ONLY],
    readOnlyByPermissions: state.surveyRunner[READ_ONLY_BY_PERMISSIONS]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      jumpToPage,
      hidePreviewSurvey,
      showHideOverview,
      loadPredefinedList,
      loadDetails,
      propertyChange,
      saveSurveyResultAndStayInRunner
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyFooter);
